import { WizardPage } from '../../components/wizard/types';
import { DeclarantRndEntityRelationshipEnumDesc, DeclareAndSubmitApplicationModel, RndDeclarationModel  } from '../../api/models';
import { FieldModel } from '../../components/form/pageForm/types';
import { titleSelectInputProps, yesNoRadioButtonProps } from '../CommonComponentProps';

const afiAppGuidanceText: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'globalContent',
    label: '',
    name: 'afiAppGuidanceText',
    contentKey: ['AFIAppGuidanceText'],
};

// Q - 124
const isDeclarantSameAsPrimaryCompanyContact = yesNoRadioButtonProps(
    'isDeclarantSameAsPrimaryCompanyContact',
    'Is the Declarant the same as the Primary Company contact?',
    ['AFIDeclarationSameAsPrimaryCompanyContact']);

// Q - 125
const declarantDetailsLabel: FieldModel<RndDeclarationModel> = {
    component: 'heading',
    label: 'Declarant details',
    name: 'declarantDetailsLabel',
    contentKey: ['RnDDeclarantDetails'],
    componentProps: {
        tag: 'h2',
        className: 'rdtiH2',
    },
};

const primaryCompanyContact: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'declarantInput',
    label: '',
    name: 'primaryCompanyContact',
};

// Q - 125.1
const title = titleSelectInputProps('title', 'Title (optional)', true);

// Q - 125.2
const titleOther: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'textInput',
    label: 'Other title',
    name: 'titleOther',
    maxWidth: '10rem',
    maxLength: 30,
};

// Q - 125.3
const firstName: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'textInput',
    label: 'First name',
    name: 'firstName',
    maxWidth: '22rem',
    maxLength: 50,
};

// Q - 125.4
const lastName: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'textInput',
    label: 'Last name',
    name: 'lastName',
    maxWidth: '22rem',
    maxLength: 50,
};

// Q - 125.5
const position: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'textInput',
    label: 'Position or role',
    name: 'position',
    maxWidth: '22rem',
    maxLength: 50,
};

// Q - 125.6
const phone: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'textInput',
    label: 'Phone number',
    name: 'phone',
    maxWidth: '16.25rem',
    contentKey: ['RnDDeclarantPhoneNumber'],
    pdfFieldProps: {
        displayFlag: 'twoLines',
        displayWhenEmpty: true,
    },
};

// Q - 125.7
const email: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'textInput',
    label: 'Email',
    name: 'email',
    maxWidth: '22rem',
    maxLength: 100,
    contentKey: ['ContactDetailsEmail'],
    pdfFieldProps: {
        displayFlag: 'twoLines',
        displayWhenEmpty: true,
    },
};

// Q - 125.8
const entityDetails: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'abnAcnLookup',
    label: 'Company ABN',
    name: 'entityDetails',
    contentKey: ['RnDDeclarantCompanyAbn'],
};

// Q - 126
const declarantRelationshipWithCompany: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'radiobuttonGroup',
    label: 'What is the Declarant\’s relationship with the R&D entity?',
    name: 'declarantRelationshipWithCompany',
    componentProps: {
        name: 'declarantRelationshipWithCompany',
        radioOptions: [
            {
                label: DeclarantRndEntityRelationshipEnumDesc['AuthorizedPerson'],
                value: 'AuthorizedPerson',
            },
            {
                label: DeclarantRndEntityRelationshipEnumDesc['ActingOnBehalfPerson'],
                value: 'ActingOnBehalfPerson',
            },
        ],
    },
};

// Q - 127
// rndDeclarationDeclaration is just a container for Content
const declarationTextLabel: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'declarationText',
    label: '',
    name: 'rndDeclaration',
    contentKey: ['RndDeclaration'],
};

const hasAcceptedDeclaration: FieldModel<DeclareAndSubmitApplicationModel> = {
    component: 'checkbox',
    legend: '',
    label: 'I agree',
    name: 'hasAcceptedDeclaration',
    maxWidth: '22rem',
};

const rndDeclaration: WizardPage<DeclareAndSubmitApplicationModel> = {
    enablingPages: [
        'registrationType',
        'rndEntityDetails',
        'contactDetails',
        'applicationInclusions',
    ],
    apiEndpoint: '/rnd-declaration',
    name: 'rndDeclaration',
    title: 'Declare and submit',
    fields: {
        afiAppGuidanceText,
        isDeclarantSameAsPrimaryCompanyContact,
        declarantDetailsLabel,
        primaryCompanyContact,
        title,
        titleOther,
        firstName,
        lastName,
        position,
        phone,
        email,
        entityDetails,
        declarantRelationshipWithCompany,
        declarationTextLabel,
        hasAcceptedDeclaration,
    },
    initialPageValues: {
        isDeclarantSameAsPrimaryCompanyContact: undefined,
        primaryCompanyContact: {
            title: undefined,
            titleOther: undefined,
            firstName: undefined,
            lastName: undefined,
            position: undefined,
            phone: undefined,
            email: undefined,
        },
        email: undefined,
        entityDetails: undefined,
        firstName: undefined,
        lastName: undefined,
        phone: undefined,
        position: undefined,
        title: undefined,
        titleOther: undefined,
        declarantRelationshipWithCompany: undefined,
        hasAcceptedDeclaration: undefined,

    },
    showSubmitConfirmationModal: true,
};

export default rndDeclaration;
